var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper"},[_c('rounded-elsa-pentagon',{staticClass:"elsa-chart",attrs:{"score":_vm.score,"chart_size":_vm.chart_size,"border_radius":_vm.border_radius}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }